<template>
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00005 0.5H9.67005C12.9801 0.5 14.3401 2.85 12.6801 5.72L11.3401 8.03L10.0001 10.34C8.34005 13.21 5.63005 13.21 3.97005 10.34L2.63005 8.03L1.29005 5.72C-0.339949 2.85 1.01005 0.5 4.33005 0.5H7.00005Z"
      :fill="clr"
    />
  </svg>
</template>

<script>
export default {
  props: {
    clr: {
      default: "var(--v-gray4-base)"
    }
  }
};
</script>
